import React from 'react';

import Part from './Part';
import QuotedQuantity from './QuotedQuantity';
import { PartPreview } from '../Quotes';

interface Props {
    handleAddItem: (item: {
        name: string;
        quote_has_product: number;
        quantity: string;
        unit_price: string;
        product_description: string;
    }) => Promise<any>;
    parentLineItems: any[];
}

export const QuotedLineItems = (props: Props) => {
    return (
        <>
            {props.parentLineItems.map(line_item => {
                return (
                    <div className={'mt-4'} key={line_item.id}>
                        <div className="part">
                            <div style={{ float: 'left' }}>
                                <PartPreview
                                    thumbnail={line_item.product.thumbnail}
                                    has_file_3d={line_item.product.has_file_3d}
                                />
                            </div>
                            <Part
                                part={{
                                    name: line_item.name,
                                    dimensions: line_item.product?.dimensions,
                                    coating: line_item.product?.coating_related?.name,
                                    finish: line_item.product?.finish_related?.name,
                                    material: line_item.product?.material_related?.name,
                                }}
                            />
                        </div>

                        <div className={'quotes mt-2'}>
                            <table className="table-layout: auto; w-full">
                                <thead>
                                    <tr>
                                        <th className="ant-table-cell">Qty</th>
                                        <th className="ant-table-cell">Unit Price</th>
                                        <th className="ant-table-cell">Total Price</th>
                                        <th className="ant-table-cell">Actions</th>
                                    </tr>
                                </thead>
                                <tbody className="ant-table-tbody">
                                    {line_item.has_dynamic_quantities ? (
                                        line_item.quote_item_quantities.map((dynamic: any) => {
                                            return (
                                                <tr key={dynamic.id}>
                                                    <QuotedQuantity
                                                        key={dynamic.id + dynamic.quantity}
                                                        quantity={dynamic.quantity}
                                                        unit_price={dynamic.unit_price}
                                                        total_price={dynamic.total_price}
                                                        onClick={async () => {
                                                            await props.handleAddItem({
                                                                name: line_item.name,
                                                                quote_has_product: line_item.id,
                                                                quantity: dynamic.quantity,
                                                                unit_price: dynamic.unit_price,
                                                                product_description: '',
                                                            });
                                                        }}
                                                    />
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <QuotedQuantity
                                                quantity={line_item.quantity}
                                                unit_price={line_item.unit_price}
                                                total_price={line_item.total_price}
                                                onClick={async () => {
                                                    await props.handleAddItem({
                                                        name: line_item.name,
                                                        quote_has_product: line_item.id,
                                                        quantity: line_item.quantity,
                                                        unit_price: line_item.unit_price,
                                                        product_description: '',
                                                    });
                                                }}
                                            />
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                );
            })}
        </>
    );
};
